<template>
  <div class="magic-token">
    <PageOverlay v-if="isLoading" />
    <CallerListener
      v-if="callerListenerAvailable"
      :roomId="roomId"
      :conversationId="conversationId"
      :agencyId="agencyId"
      :accessToken="accessToken"
    />
    <div v-if="!showHeader" class="row">
      <div class="col-12 text-center p-0">
        <div v-if="error" class="text-center p-3 card" >{{ error }}</div>
        <div v-else-if="tokenComponent" class="card p-3">
          <component :is="tokenComponent" :magicToken="magicToken" />
        </div>
      </div>
    </div>
    <template v-else>
      <div v-if="error" class="row">
        <div class="col-12 text-center p-0">
          <div class="text-center p-3 card" >{{ error }}</div>
        </div>
      </div>
      <AccountCreation v-else :magicToken="magicToken" />
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import PageOverlay from "../components/PageOverlay";
import VideoRoom from "../components/VideoRoom";
import GeoFinder from "../components/GeoFinder";
import AccountCreation from "../components/AccountCreation.vue";
import CallerListener from "../sockets/CallerListener";
import ArtifactDownload from "../components/ArtifactDownload";
import { EventBus } from "../events/eventBus";
import { recognitionLanguages } from "../constants";

export default {
  components: {
    PageOverlay,
    CallerListener,
    AccountCreation,
  },
  data() {
    return {
      token: this.$route.params.token,
      tokenComponent: null,
      magicToken: null,
      error: null,
      isLoading: false,
      deviceLanguage: navigator.language,
      connectedParticipants: [],
    };
  },
  async created() {
    this.isLoading = true;

    if (this.token) {
      await this.getMagicToken(this.token);
      // await this.getParticipants();
      this.getTokenComponent();

      if (this.tokenComponent && this.magicToken.service_type === "createVideoRoomToken") {
        try {
          const conversationId = this.magicToken.token_data.conversation_id;
          const resp = await this.$ConveyApi.conversationsApi.getConversation({ conversationId });
          let isSelfLangSet = false;

          // this.$store.commit("transcription/setTranscribing", this.magicToken.token_data.enableTranscription === 'true');

          if (resp.data.data.recipients) {
            resp.data.data.recipients.forEach(recipient => {
              const { number, language } = recipient;
              const recogLang = recognitionLanguages.find(item => item.split('-')[0] == language)

              if (!recogLang) return;

              const option = {};
              option[number] = recogLang;

              if (number == this.magicToken.token_data.recipient) {
                this.$store.commit("transcription/setSelfRecognitionLanguage", recogLang);
                isSelfLangSet = true;
              } else {
                this.$store.commit("transcription/setRecognitionLanguages", option);
              }
            })
          }

          if (!isSelfLangSet) {
            navigator.language ? this.updateRecipientLanguage(navigator.language) : this.updateRecipientLanguage('en-US');
          }
        } catch (error) {
          console.log(error)
        }
      }
    } else
      this.error = "Not Authorized";

    this.isLoading = false;
  },
  computed: {
    roomId() {
      return this.magicToken ? this.magicToken.token_data.room_id : null;
    },
    accessToken() {
      return this.magicToken ? this.magicToken.access_token : null;
    },
    conversationId() {
      return this.magicToken ? this.magicToken.token_data.conversation_id : null;
    },
    agencyId() {
      return this.magicToken ? this.magicToken.token_data.agency_id : null;
    },
    callerListenerAvailable() {
      return this.magicToken && (this.magicToken.service_type == 'createVideoRoomToken' || this.magicToken.service_type == 'addRecipientGeolocation');
    },
    showHeader() {
      if (this.magicToken && this.magicToken.service_type) {
        return ["updateCurrentUser", "createUser", "fulfillUserInvitation"].includes(this.magicToken.service_type);
      }
      return false;
    }
  },
  methods: {
    async updateRecipientLanguage(langCode) {
      if (!this.magicToken.recipient_id)
        return;

      try {
        const lang = langCode.split('-')[0].toLowerCase();
        await this.$ConveyApi.recipientsApi.updateRecipientLanguage({
          numberOrId: this.magicToken.recipient_id,
          language: lang,
        });
      } catch (err) {
        console.log(err)
      }

      this.shareLanguageInfo(lang);
    },
    shareLanguageInfo(lang) {
      if (this.magicToken.service_type != "createVideoRoomToken") return;

      const recogLang = recognitionLanguages.find(item => item.split('-')[0] == lang)

      if (recogLang) {
        const shareData = {};
        shareData[`${this.magicToken.token_data.recipient}`] = recogLang;
        EventBus.$emit('share-information', {
          conversationId: this.conversationId,
          type: 'recognition-language',
          data: {...shareData}
        });
        this.$store.commit("transcription/setSelfRecognitionLanguage", recogLang);
      }
    },
    getTokenComponent() {
      if (!this.magicToken) {
        this.error = "Token has expired or is invalid";
        return;
      }
      if (this.magicToken.service_type === "addRecipientGeolocation")
        this.tokenComponent = GeoFinder;
      else if (this.magicToken.service_type === "createVideoRoomToken") {
        this.tokenComponent = VideoRoom;
      }
      else if (["updateCurrentUser", "createUser", "fulfillUserInvitation"].includes(this.magicToken.service_type))
        this.tokenComponent = AccountCreation;
      else if (this.magicToken.service_type === "downloadArtifact")
        this.tokenComponent = ArtifactDownload;
      else
        this.error = "Unsupported Token Service Type";

    },
    async getMagicToken(token) {
      try {
        const resp = await this.$ConveyApi.tokensApi.getMagicToken({ token });
        this.magicToken = resp.data.data;
        this.$store.commit("user/setUserJwt", this.magicToken.access_token);
        this.$store.commit("agency/setCurrentAgency", { agency_id: this.magicToken.agency_id });
      } catch (err) {
        this.error = "Token has expired or is invalid";
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.remote_video_container {
  left: 0;
  margin: 0;
  border: 1px solid rgb(124, 129, 124);
}
#localTrack video {
  border: 3px solid rgb(124, 129, 124);
  margin: 0px;
  max-width: 50% !important;
  background-repeat: no-repeat;
}
.spacing {
  padding: 20px;
    width: 100%;
}
.roomTitle {
  border: 1px solid rgb(124, 129, 124);
  padding: 4px;
  color: dodgerblue;
}
</style>

<style lang="scss" scoped>
.magic-token {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
